// Copyright (c) 2025 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export function IOTABridgeLogo(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
    return (
        <svg
            width="187"
            height="36"
            viewBox="0 0 187 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_6130_35231)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M76.1746 6.28059C69.8135 6.28059 64.4043 11.7958 64.4043 18.308C64.4043 24.8612 69.8504 30.3727 76.1746 30.3354C82.5357 30.3354 87.9043 24.8612 87.9043 18.308C87.9043 11.7547 82.5726 6.28059 76.1746 6.28059ZM76.1746 8.7488C81.1262 8.7488 85.2772 13.1438 85.2772 18.308C85.2772 23.5132 81.1262 27.9045 76.1746 27.9045C71.2229 27.9045 67.0351 23.5132 67.0351 18.308C67.0351 13.1438 71.2229 8.7488 76.1746 8.7488Z"
                    fill="currentColor"
                />
                <path d="M53.3203 6.70638H55.9474V29.9471H53.3203V6.70638Z" fill="currentColor" />
                <path
                    d="M101.387 9.21192H93.6565V6.70638H111.71V9.21192H103.977V29.9471H101.35L101.387 9.21192Z"
                    fill="currentColor"
                />
                <path
                    d="M116.773 29.9471L125.495 9.9438L134.144 29.9471H137L127.44 8.01703C127.097 7.20674 126.333 6.70638 125.458 6.70638C124.621 6.70638 123.82 7.20674 123.477 8.01703L113.917 29.9471H116.773Z"
                    fill="currentColor"
                />
                <path
                    d="M26.9277 4.31656C28.1056 4.31656 29.0604 3.35027 29.0604 2.15828C29.0604 0.966296 28.1056 0 26.9277 0C25.7499 0 24.795 0.966296 24.795 2.15828C24.795 3.35027 25.7499 4.31656 26.9277 4.31656Z"
                    fill="currentColor"
                />
                <path
                    d="M29.326 34.8051C30.5039 34.8051 31.4587 33.8388 31.4587 32.6468C31.4587 31.4548 30.5039 30.4885 29.326 30.4885C28.1482 30.4885 27.1934 31.4548 27.1934 32.6468C27.1934 33.8388 28.1482 34.8051 29.326 34.8051Z"
                    fill="currentColor"
                />
                <path
                    d="M27.5365 9.71227C28.5248 9.71227 29.326 8.90145 29.326 7.90125C29.326 6.90106 28.5248 6.09024 27.5365 6.09024C26.5482 6.09024 25.747 6.90106 25.747 7.90125C25.747 8.90145 26.5482 9.71227 27.5365 9.71227Z"
                    fill="currentColor"
                />
                <path
                    d="M32.2963 10.4068C33.2846 10.4068 34.0858 9.59599 34.0858 8.59579C34.0858 7.5956 33.2846 6.78478 32.2963 6.78478C31.308 6.78478 30.5068 7.5956 30.5068 8.59579C30.5068 9.59599 31.308 10.4068 32.2963 10.4068Z"
                    fill="currentColor"
                />
                <path
                    d="M26.9277 14.3014C27.7693 14.3014 28.4516 13.611 28.4516 12.7593C28.4516 11.9075 27.7693 11.2171 26.9277 11.2171C26.0861 11.2171 25.4039 11.9075 25.4039 12.7593C25.4039 13.611 26.0861 14.3014 26.9277 14.3014Z"
                    fill="currentColor"
                />
                <path
                    d="M31.6875 14.9549C32.5291 14.9549 33.2113 14.2644 33.2113 13.4127C33.2113 12.561 32.5291 11.8706 31.6875 11.8706C30.8459 11.8706 30.1636 12.561 30.1636 13.4127C30.1636 14.2644 30.8459 14.9549 31.6875 14.9549Z"
                    fill="currentColor"
                />
                <path
                    d="M35.4953 16.4597C36.3369 16.4597 37.0192 15.7692 37.0192 14.9175C37.0192 14.0658 36.3369 13.3754 35.4953 13.3754C34.6537 13.3754 33.9714 14.0658 33.9714 14.9175C33.9714 15.7692 34.6537 16.4597 35.4953 16.4597Z"
                    fill="currentColor"
                />
                <path
                    d="M30.278 18.6553C31.0136 18.6553 31.61 18.0518 31.61 17.3073C31.61 16.5629 31.0136 15.9593 30.278 15.9593C29.5424 15.9593 28.946 16.5629 28.946 17.3073C28.946 18.0518 29.5424 18.6553 30.278 18.6553Z"
                    fill="currentColor"
                />
                <path
                    d="M25.5182 17.9981C26.2539 17.9981 26.8502 17.3946 26.8502 16.6501C26.8502 15.9057 26.2539 15.3021 25.5182 15.3021C24.7826 15.3021 24.1862 15.9057 24.1862 16.6501C24.1862 17.3946 24.7826 17.9981 25.5182 17.9981Z"
                    fill="currentColor"
                />
                <path
                    d="M34.1264 20.1564C34.862 20.1564 35.4584 19.5529 35.4584 18.8084C35.4584 18.0639 34.862 17.4604 34.1264 17.4604C33.3908 17.4604 32.7944 18.0639 32.7944 18.8084C32.7944 19.5529 33.3908 20.1564 34.1264 20.1564Z"
                    fill="currentColor"
                />
                <path
                    d="M28.3741 21.4708C29.0058 21.4708 29.5179 20.9525 29.5179 20.3132C29.5179 19.6739 29.0058 19.1557 28.3741 19.1557C27.7424 19.1557 27.2303 19.6739 27.2303 20.3132C27.2303 20.9525 27.7424 21.4708 28.3741 21.4708Z"
                    fill="currentColor"
                />
                <path
                    d="M32.2225 22.9346C32.8542 22.9346 33.3663 22.4163 33.3663 21.777C33.3663 21.1377 32.8542 20.6194 32.2225 20.6194C31.5908 20.6194 31.0787 21.1377 31.0787 21.777C31.0787 22.4163 31.5908 22.9346 32.2225 22.9346Z"
                    fill="currentColor"
                />
                <path
                    d="M23.6512 20.7763C24.2829 20.7763 24.795 20.258 24.795 19.6187C24.795 18.9794 24.2829 18.4612 23.6512 18.4612C23.0195 18.4612 22.5074 18.9794 22.5074 19.6187C22.5074 20.258 23.0195 20.7763 23.6512 20.7763Z"
                    fill="currentColor"
                />
                <path
                    d="M26.2783 23.3565C26.8041 23.3565 27.2303 22.9252 27.2303 22.3931C27.2303 21.8611 26.8041 21.4297 26.2783 21.4297C25.7526 21.4297 25.3264 21.8611 25.3264 22.3931C25.3264 22.9252 25.7526 23.3565 26.2783 23.3565Z"
                    fill="currentColor"
                />
                <path
                    d="M27.9166 26.0189C28.3791 26.0189 28.7541 25.6394 28.7541 25.1713C28.7541 24.7031 28.3791 24.3236 27.9166 24.3236C27.454 24.3236 27.079 24.7031 27.079 25.1713C27.079 25.6394 27.454 26.0189 27.9166 26.0189Z"
                    fill="currentColor"
                />
                <path
                    d="M25.8983 26.5566C26.2773 26.5566 26.5846 26.2456 26.5846 25.8621C26.5846 25.4785 26.2773 25.1675 25.8983 25.1675C25.5193 25.1675 25.212 25.4785 25.212 25.8621C25.212 26.2456 25.5193 26.5566 25.8983 26.5566Z"
                    fill="currentColor"
                />
                <path
                    d="M24.1088 24.5514C24.5713 24.5514 24.9463 24.1719 24.9463 23.7038C24.9463 23.2356 24.5713 22.8561 24.1088 22.8561C23.6462 22.8561 23.2712 23.2356 23.2712 23.7038C23.2712 24.1719 23.6462 24.5514 24.1088 24.5514Z"
                    fill="currentColor"
                />
                <path
                    d="M21.5186 22.703C22.0443 22.703 22.4705 22.2717 22.4705 21.7397C22.4705 21.2076 22.0443 20.7763 21.5186 20.7763C20.9928 20.7763 20.5666 21.2076 20.5666 21.7397C20.5666 22.2717 20.9928 22.703 21.5186 22.703Z"
                    fill="currentColor"
                />
                <path
                    d="M21.4817 15.4552C22.0074 15.4552 22.4336 15.0239 22.4336 14.4919C22.4336 13.9598 22.0074 13.5285 21.4817 13.5285C20.9559 13.5285 20.5297 13.9598 20.5297 14.4919C20.5297 15.0239 20.9559 15.4552 21.4817 15.4552Z"
                    fill="currentColor"
                />
                <path
                    d="M21.8986 12.0647C22.3612 12.0647 22.7362 11.6852 22.7362 11.2171C22.7362 10.749 22.3612 10.3695 21.8986 10.3695C21.436 10.3695 21.061 10.749 21.061 11.2171C21.061 11.6852 21.436 12.0647 21.8986 12.0647Z"
                    fill="currentColor"
                />
                <path
                    d="M22.8137 9.29033C23.1927 9.29033 23.4999 8.97937 23.4999 8.59579C23.4999 8.21221 23.1927 7.90126 22.8137 7.90126C22.4346 7.90126 22.1274 8.21221 22.1274 8.59579C22.1274 8.97937 22.4346 9.29033 22.8137 9.29033Z"
                    fill="currentColor"
                />
                <path
                    d="M21.216 7.97967C21.6786 7.97967 22.0536 7.60017 22.0536 7.13204C22.0536 6.6639 21.6786 6.28441 21.216 6.28441C20.7534 6.28441 20.3784 6.6639 20.3784 7.13204C20.3784 7.60017 20.7534 7.97967 21.216 7.97967Z"
                    fill="currentColor"
                />
                <path
                    d="M30.0898 24.824C30.6156 24.824 31.0418 24.3927 31.0418 23.8606C31.0418 23.3285 30.6156 22.8972 30.0898 22.8972C29.5641 22.8972 29.1379 23.3285 29.1379 23.8606C29.1379 24.3927 29.5641 24.824 30.0898 24.824Z"
                    fill="currentColor"
                />
                <path
                    d="M19.0427 6.85946C19.5685 6.85946 19.9947 6.42813 19.9947 5.89607C19.9947 5.36401 19.5685 4.93268 19.0427 4.93268C18.517 4.93268 18.0908 5.36401 18.0908 5.89607C18.0908 6.42813 18.517 6.85946 19.0427 6.85946Z"
                    fill="currentColor"
                />
                <path
                    d="M19.6921 10.9445C20.2179 10.9445 20.6441 10.5132 20.6441 9.98113C20.6441 9.44906 20.2179 9.01774 19.6921 9.01774C19.1664 9.01774 18.7402 9.44906 18.7402 9.98113C18.7402 10.5132 19.1664 10.9445 19.6921 10.9445Z"
                    fill="currentColor"
                />
                <path
                    d="M18.6258 14.8391C19.2575 14.8391 19.7696 14.3209 19.7696 13.6816C19.7696 13.0423 19.2575 12.524 18.6258 12.524C17.9941 12.524 17.482 13.0423 17.482 13.6816C17.482 14.3209 17.9941 14.8391 18.6258 14.8391Z"
                    fill="currentColor"
                />
                <path
                    d="M15.1574 14.8391C15.8931 14.8391 16.4894 14.2356 16.4894 13.4911C16.4894 12.7467 15.8931 12.1431 15.1574 12.1431C14.4218 12.1431 13.8255 12.7467 13.8255 13.4911C13.8255 14.2356 14.4218 14.8391 15.1574 14.8391Z"
                    fill="currentColor"
                />
                <path
                    d="M11.1209 15.7652C11.9625 15.7652 12.6447 15.0747 12.6447 14.223C12.6447 13.3713 11.9625 12.6808 11.1209 12.6808C10.2793 12.6808 9.59701 13.3713 9.59701 14.223C9.59701 15.0747 10.2793 15.7652 11.1209 15.7652Z"
                    fill="currentColor"
                />
                <path
                    d="M6.70426 17.9608C7.69259 17.9608 8.49378 17.15 8.49378 16.1498C8.49378 15.1496 7.69259 14.3388 6.70426 14.3388C5.71593 14.3388 4.91474 15.1496 4.91474 16.1498C4.91474 17.15 5.71593 17.9608 6.70426 17.9608Z"
                    fill="currentColor"
                />
                <path
                    d="M2.13267 21.6612C3.31051 21.6612 4.26534 20.6949 4.26534 19.503C4.26534 18.311 3.31051 17.3447 2.13267 17.3447C0.954829 17.3447 0 18.311 0 19.503C0 20.6949 0.954829 21.6612 2.13267 21.6612Z"
                    fill="currentColor"
                />
                <path
                    d="M4.91473 13.4501C5.90306 13.4501 6.70426 12.6392 6.70426 11.639C6.70426 10.6388 5.90306 9.82802 4.91473 9.82802C3.92641 9.82802 3.12521 10.6388 3.12521 11.639C3.12521 12.6392 3.92641 13.4501 4.91473 13.4501Z"
                    fill="currentColor"
                />
                <path
                    d="M9.33135 11.2544C10.173 11.2544 10.8552 10.564 10.8552 9.71228C10.8552 8.86056 10.173 8.17011 9.33135 8.17011C8.48974 8.17011 7.80748 8.86056 7.80748 9.71228C7.80748 10.564 8.48974 11.2544 9.33135 11.2544Z"
                    fill="currentColor"
                />
                <path
                    d="M8.68564 7.16938C9.52725 7.16938 10.2095 6.47893 10.2095 5.62722C10.2095 4.77551 9.52725 4.08506 8.68564 4.08506C7.84404 4.08506 7.16178 4.77551 7.16178 5.62722C7.16178 6.47893 7.84404 7.16938 8.68564 7.16938Z"
                    fill="currentColor"
                />
                <path
                    d="M12.7222 6.24333C13.4579 6.24333 14.0542 5.63982 14.0542 4.89534C14.0542 4.15087 13.4579 3.54735 12.7222 3.54735C11.9866 3.54735 11.3902 4.15087 11.3902 4.89534C11.3902 5.63982 11.9866 6.24333 12.7222 6.24333Z"
                    fill="currentColor"
                />
                <path
                    d="M16.1869 6.24707C16.8186 6.24707 17.3307 5.72881 17.3307 5.08951C17.3307 4.45021 16.8186 3.93196 16.1869 3.93196C15.5552 3.93196 15.0431 4.45021 15.0431 5.08951C15.0431 5.72881 15.5552 6.24707 16.1869 6.24707Z"
                    fill="currentColor"
                />
                <path
                    d="M16.8326 10.3321C17.4643 10.3321 17.9764 9.81387 17.9764 9.17457C17.9764 8.53527 17.4643 8.01701 16.8326 8.01701C16.2009 8.01701 15.6888 8.53527 15.6888 9.17457C15.6888 9.81387 16.2009 10.3321 16.8326 10.3321Z"
                    fill="currentColor"
                />
                <path
                    d="M13.3679 10.3657C14.1036 10.3657 14.6999 9.76221 14.6999 9.01773C14.6999 8.27326 14.1036 7.66974 13.3679 7.66974C12.6323 7.66974 12.0359 8.27326 12.0359 9.01773C12.0359 9.76221 12.6323 10.3657 13.3679 10.3657Z"
                    fill="currentColor"
                />
                <path
                    d="M9.59701 20.6232C9.97604 20.6232 10.2833 20.3122 10.2833 19.9286C10.2833 19.5451 9.97604 19.2341 9.59701 19.2341C9.21798 19.2341 8.91072 19.5451 8.91072 19.9286C8.91072 20.3122 9.21798 20.6232 9.59701 20.6232Z"
                    fill="currentColor"
                />
                <path
                    d="M12.3385 20.2722C12.8011 20.2722 13.1761 19.8927 13.1761 19.4245C13.1761 18.9564 12.8011 18.5769 12.3385 18.5769C11.8759 18.5769 11.5009 18.9564 11.5009 19.4245C11.5009 19.8927 11.8759 20.2722 12.3385 20.2722Z"
                    fill="currentColor"
                />
                <path
                    d="M15.3493 19.1183C15.8751 19.1183 16.3013 18.687 16.3013 18.155C16.3013 17.6229 15.8751 17.1916 15.3493 17.1916C14.8236 17.1916 14.3974 17.6229 14.3974 18.155C14.3974 18.687 14.8236 19.1183 15.3493 19.1183Z"
                    fill="currentColor"
                />
                <path
                    d="M16.0725 22.2027C16.7042 22.2027 17.2163 21.6844 17.2163 21.0451C17.2163 20.4058 16.7042 19.8876 16.0725 19.8876C15.4408 19.8876 14.9287 20.4058 14.9287 21.0451C14.9287 21.6844 15.4408 22.2027 16.0725 22.2027Z"
                    fill="currentColor"
                />
                <path
                    d="M12.416 22.9345C12.9417 22.9345 13.3679 22.5032 13.3679 21.9712C13.3679 21.4391 12.9417 21.0078 12.416 21.0078C11.8902 21.0078 11.464 21.4391 11.464 21.9712C11.464 22.5032 11.8902 22.9345 12.416 22.9345Z"
                    fill="currentColor"
                />
                <path
                    d="M9.18007 22.8935C9.64265 22.8935 10.0176 22.514 10.0176 22.0458C10.0176 21.5777 9.64265 21.1982 9.18007 21.1982C8.71749 21.1982 8.3425 21.5777 8.3425 22.0458C8.3425 22.514 8.71749 22.8935 9.18007 22.8935Z"
                    fill="currentColor"
                />
                <path
                    d="M9.21696 25.5559C9.74271 25.5559 10.1689 25.1245 10.1689 24.5925C10.1689 24.0604 9.74271 23.6291 9.21696 23.6291C8.69122 23.6291 8.26501 24.0604 8.26501 24.5925C8.26501 25.1245 8.69122 25.5559 9.21696 25.5559Z"
                    fill="currentColor"
                />
                <path
                    d="M13.1023 26.0562C13.734 26.0562 14.2461 25.538 14.2461 24.8987C14.2461 24.2594 13.734 23.7411 13.1023 23.7411C12.4705 23.7411 11.9584 24.2594 11.9584 24.8987C11.9584 25.538 12.4705 26.0562 13.1023 26.0562Z"
                    fill="currentColor"
                />
                <path
                    d="M17.6333 25.5521C18.3689 25.5521 18.9653 24.9486 18.9653 24.2041C18.9653 23.4597 18.3689 22.8561 17.6333 22.8561C16.8976 22.8561 16.3013 23.4597 16.3013 24.2041C16.3013 24.9486 16.8976 25.5521 17.6333 25.5521Z"
                    fill="currentColor"
                />
                <path
                    d="M20.3009 28.909C21.1425 28.909 21.8248 28.2186 21.8248 27.3669C21.8248 26.5152 21.1425 25.8247 20.3009 25.8247C19.4593 25.8247 18.7771 26.5152 18.7771 27.3669C18.7771 28.2186 19.4593 28.909 20.3009 28.909Z"
                    fill="currentColor"
                />
                <path
                    d="M14.6999 29.3683C15.4356 29.3683 16.0319 28.7648 16.0319 28.0203C16.0319 27.2759 15.4356 26.6723 14.6999 26.6723C13.9643 26.6723 13.3679 27.2759 13.3679 28.0203C13.3679 28.7648 13.9643 29.3683 14.6999 29.3683Z"
                    fill="currentColor"
                />
                <path
                    d="M11.5415 31.9896C12.2771 31.9896 12.8735 31.3861 12.8735 30.6416C12.8735 29.8972 12.2771 29.2936 11.5415 29.2936C10.8059 29.2936 10.2095 29.8972 10.2095 30.6416C10.2095 31.3861 10.8059 31.9896 11.5415 31.9896Z"
                    fill="currentColor"
                />
                <path
                    d="M14.1686 35.3839C15.0102 35.3839 15.6925 34.6934 15.6925 33.8417C15.6925 32.99 15.0102 32.2996 14.1686 32.2996C13.327 32.2996 12.6447 32.99 12.6447 33.8417C12.6447 34.6934 13.327 35.3839 14.1686 35.3839Z"
                    fill="currentColor"
                />
                <path
                    d="M21.1754 36C22.1637 36 22.9649 35.1892 22.9649 34.189C22.9649 33.1888 22.1637 32.378 21.1754 32.378C20.1871 32.378 19.3859 33.1888 19.3859 34.189C19.3859 35.1892 20.1871 36 21.1754 36Z"
                    fill="currentColor"
                />
                <path
                    d="M17.3307 32.7626C18.1723 32.7626 18.8546 32.0721 18.8546 31.2204C18.8546 30.3687 18.1723 29.6783 17.3307 29.6783C16.4891 29.6783 15.8068 30.3687 15.8068 31.2204C15.8068 32.0721 16.4891 32.7626 17.3307 32.7626Z"
                    fill="currentColor"
                />
                <path
                    d="M24.1088 32.1465C25.0971 32.1465 25.8983 31.3356 25.8983 30.3354C25.8983 29.3352 25.0971 28.5244 24.1088 28.5244C23.1204 28.5244 22.3192 29.3352 22.3192 30.3354C22.3192 31.3356 23.1204 32.1465 24.1088 32.1465Z"
                    fill="currentColor"
                />
                <path
                    d="M9.94016 28.6775C10.5719 28.6775 11.084 28.1593 11.084 27.52C11.084 26.8807 10.5719 26.3624 9.94016 26.3624C9.30845 26.3624 8.79634 26.8807 8.79634 27.52C8.79634 28.1593 9.30845 28.6775 9.94016 28.6775Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
}
